import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")
  const _component_q_spinner = _resolveComponent("q-spinner")
  const _component_q_btn = _resolveComponent("q-btn")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_q_select, {
      class: "q-mb-md",
      style: {"max-width":"500px"},
      modelValue: _ctx.model,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.model = $event)),
      options: _ctx.options,
      label: "Jurisdicción",
      "option-value": "id",
      "option-label": "descripcion",
      loading: _ctx.loadingFueros,
      disable: _ctx.loadingFueros,
      "map-options": "",
      "emit-value": ""
    }, null, 8, ["modelValue", "options", "loading", "disable"]),
    (_ctx.loadingPeritos)
      ? (_openBlock(), _createBlock(_component_q_spinner, {
          key: 0,
          color: "primary"
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.links, (item) => {
      return (_openBlock(), _createBlock("ul", {
        key: item.id
      }, [
        _createVNode("li", null, [
          _createVNode(_component_q_btn, {
            flat: "",
            icon: "download",
            color: "primary",
            label: item.descripcion,
            loading: _ctx.downloadingId === item.id,
            disable: _ctx.downloadingId !== null,
            onClick: ($event: any) => (_ctx.download(item.id))
          }, null, 8, ["label", "loading", "disable", "onClick"])
        ])
      ]))
    }), 128))
  ], 64))
}